import { Paragraph as BaseParagraph } from '../Shared.styled';
import styled from 'styled-components';

export const InfoSection = styled.ul`
  margin-top: 12px;
  padding-left: 0;
  list-style-type: none;
`;

export const InfoHeader = styled.p`
  margin: 0 0 8px 0;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
`;

export const InfoItem = styled.li`
  padding: 12px 0 12px 20px;
  border-top: 1px solid #abaeba;
  position: relative;

  &::before {
    content: '•';
    position: absolute;
    left: 2px;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const InfoItemTitle = styled.span`
  display: block;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
`;

export const Paragraph = styled(BaseParagraph)`
  margin: 4px 0 0 0;
`;
